export default {
    ENTER: 'Enter',
    SPACE: ' ',
    ESCAPE: 'Escape',
    UP: 'ArrowUp',
    DOWN: 'ArrowDown',
    TAB: 'Tab',
};



// WEBPACK FOOTER //
// ./~/@99designs/react-components/lib/keyConstants.js